/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    UserRole,
    UserRoleFromJSON,
    UserRoleToJSON,
    UserRoleDataFrame,
    UserRoleDataFrameFromJSON,
    UserRoleDataFrameToJSON,
} from '../models';

export interface ApiUserRolesGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiUserRolesIdDeleteRequest {
    id: number;
}

export interface ApiUserRolesIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiUserRolesPostRequest {
    relations?: string;
    deleted?: boolean;
    userRole?: UserRole;
}

/**
 * no description
 */
export class UserRoleApi extends runtime.BaseAPI {

    /**
     * Get list of UserRole
     */
    async apiUserRolesGetRaw(requestParameters: ApiUserRolesGetRequest): Promise<runtime.ApiResponse<UserRoleDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userRoles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of UserRole
     */
    async apiUserRolesGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<UserRoleDataFrame> {
        const response = await this.apiUserRolesGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of UserRole
     */
    async apiUserRolesIdDeleteRaw(requestParameters: ApiUserRolesIdDeleteRequest): Promise<runtime.ApiResponse<UserRole>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserRolesIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userRoles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleFromJSON(jsonValue));
    }

    /**
     * Remove entity of UserRole
     */
    async apiUserRolesIdDelete(id: number): Promise<UserRole> {
        const response = await this.apiUserRolesIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of UserRole
     */
    async apiUserRolesIdGetRaw(requestParameters: ApiUserRolesIdGetRequest): Promise<runtime.ApiResponse<UserRole>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserRolesIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userRoles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleFromJSON(jsonValue));
    }

    /**
     * Get entity of UserRole
     */
    async apiUserRolesIdGet(id: number, relations?: string, deleted?: boolean): Promise<UserRole> {
        const response = await this.apiUserRolesIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of UserRole (if id defined)
     */
    async apiUserRolesPostRaw(requestParameters: ApiUserRolesPostRequest): Promise<runtime.ApiResponse<UserRole>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userRoles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserRoleToJSON(requestParameters.userRole),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleFromJSON(jsonValue));
    }

    /**
     * Create or update entity of UserRole (if id defined)
     */
    async apiUserRolesPost(relations?: string, deleted?: boolean, userRole?: UserRole): Promise<UserRole> {
        const response = await this.apiUserRolesPostRaw({ relations: relations, deleted: deleted, userRole: userRole });
        return await response.value();
    }

}
